<div
  class="controls"
  filterDateValidator>
  <mat-form-field>
    <mat-label>Choose a date</mat-label>
    <input
      matInput
      name="startDate"
      [(ngModel)]="filter.from"
      (ngModelChange)="updateFilterChangeTime()"
      [matDatepicker]="startDatepicker" />
    <mat-datepicker-toggle
      matIconSuffix
      [for]="startDatepicker"></mat-datepicker-toggle>
    <mat-datepicker #startDatepicker></mat-datepicker>
  </mat-form-field>

  <span class="divider">-</span>

  <mat-form-field>
    <mat-label>Choose a date</mat-label>
    <input
      matInput
      name="endDate"
      [(ngModel)]="filter.to"
      (ngModelChange)="updateFilterChangeTime()"
      [matDatepicker]="endDatepicker" />
    <mat-datepicker-toggle
      matIconSuffix
      [for]="endDatepicker"></mat-datepicker-toggle>
    <mat-datepicker #endDatepicker></mat-datepicker>
  </mat-form-field>
</div>
